<div class="trends-inspirations">
  <app-gradient class="gradient gradient__left"></app-gradient>
  <app-gradient class="gradient gradient__right"></app-gradient>
  <section class="trends-inspirations__container">
    <header class="trends-inspirations__container-header">
      <h1 class="heading-m trends-inspirations__title body-xl-bold">
        {{ 'trends-inspirations.title' | translate }}
      </h1>
      <span class="body-m trends-inspirations__subtitle">
        {{ 'trends-inspirations.subtitle' | translate }}
      </span>
    </header>
    <div class="trends-inspirations__container-content">
      <div class="trends-inspirations__filters">
        <span class="heading-s">
          {{ 'trends-inspirations.filters' | translate }}
        </span>
        @for (tagCategory of tagsCategory; track tagCategory) {
          <div class="trends-inspirations__tag-container">
            <span class="heading-xs">{{ tagCategory.name }}</span>
            <div class="trends-inspirations__tag-list-container">
              @for (tag of tagCategory.tags; track tag) {
                <div class="trends-inspirations__tag-list">
                  <mat-checkbox
                    class="bany-checkbox trends-inspirations__tag-checkbox"
                    [disabled]="isTagDisabled(tagCategory.id, tag.id)"
                    (change)="onCheckboxChange(tagCategory.id, tag.id, tag.name)"
                    [checked]="isChecked(tagCategory.id, tag.id)">{{ tag.label }}</mat-checkbox>
                </div>
              }
            </div>
          </div>
        }
      </div>
      <section class="trends-inspirations__content">
        <div class="trends-inspirations__content-heading">
          <span class="heading-xs">
            {{ 'trends-inspirations.our-latest-articles' | translate }}
          </span>
          <app-button
            (click)="toggleMobileFilterBlock()"
            class="trends-inspirations__mobile-button"
            size="small"
            icon="filter_alt"
            type="secondary"></app-button>
        </div>
        @if (isMobileFilterExpanded) {
          <div class="trends-inspirations__mobile-filters">
            <span class="heading-xs trends-inspirations__mobile-filters-title">{{'trends-inspirations.filters' | translate }}</span>
            @for (tagCategory of tagsCategory; track tagCategory) {
              <div class="trends-inspirations__mobile-tag-container">
                <span class="body-m">{{ tagCategory.name }}</span>
                <div class="trends-inspirations__mobile-tag-list">
                  @for (tag of tagCategory.tags; track tag) {
                    <app-chip
                      type="trend"
                      [text]="tag.name ? tag.name : tag.label"
                      [selected]="isChecked(tagCategory.id, tag.id)"
                      [disabled]="isTagDisabled(tagCategory.id, tag.id)"
                      (chipSelected)="updateSelectedTags(tagCategory.id, tag.id, tag.name, $event)"></app-chip>
                  }
                </div>
              </div>
            }
            <div class="trends-inspirations__clear-filter-container">
              <div class="trends-inspirations__clear-filter" (click)="clearSelectedTags()">
                <mat-icon class="trends-inspirations__clear-filter-icon icon-s">close</mat-icon>
                <span class="body-m trends-inspirations__clear-filter-text">{{'trends-inspirations.clear-filters' | translate }}</span>
              </div>
            </div>
          </div>
        }
        <div class="trends-inspirations__list">
          @for (article of articles; track article; let i=$index) {
            <div class="trends-inspiration__article" [ngClass]="{'trends-inspirations__main': i === 0, 'trends-inspiration__article': i!== 0}">
              <app-trend-article-card
                [displayStyle]="i === 0 ? 'main' : 'default'"
                [title]="article.title"
                [image]="article.image"
                [url]="article.url"
                [abstract]="article.abstract">
              </app-trend-article-card>
            </div>
          }
        </div>
        <mat-paginator
          hidePageSize="true"
          [length]="totalArticles"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          (page)="onPageChange($event)"
          class="trends-inspirations__pagination"></mat-paginator>
      </section>
    </div>
  </section>
</div>
